import {Vector3} from "three";
import { CameraImage } from "../cameras/cameras";
import {Viewer} from "../main";

class ChangeDetector {
  private viewer;
  private previousFov = 0;
  private previousZoom = 0;
  private previousLookat = new Vector3();
  private previousCamera: CameraImage;
  private previousHeight = 0;
  public lookatChanged = false;
  public fovChanged = false;
  public zoomChanged = false;
  public cameraChanged = false;
  public heightChanged = false;
  public enabled = false;

  constructor(viewer: Viewer) {
    this.viewer = viewer;
  }

  get map () {
    return this.viewer.minimap.map;
  }

  get camera() {
    return this.viewer.camera;
  }

  get newFov() {
    return this.camera.fov;
  }

  get newZoom() {
    return this.map.getView().getZoom();
  }

  get newLookat() {
    return this.viewer.lookat;
  }

  get newCamera() {
    return this.viewer.minimap.activeCamera;
  }

  get newHeight() {
    return this.viewer.height;
  }

  update() {
    try {
      this.lookatChanged = !this.previousLookat.equals(this.newLookat);
      this.fovChanged = this.newFov !== this.previousFov;
      this.zoomChanged = this.newZoom !== this.previousZoom;
      this.cameraChanged = this.previousCamera !== this.newCamera;
      this.heightChanged = this.previousHeight !== this.newHeight;

      this.previousZoom = this.newZoom;
      this.previousFov = this.newFov;
      this.previousLookat = this.newLookat;
      this.previousCamera = this.newCamera;
      this.previousHeight = this.newHeight;
    } catch {
      // Nothing
    }
  };
}

export default ChangeDetector;